module.exports = __webpack_public_path__ + "img/interaction-bar-search-nissan.1693a9d3.png";